import { ReactElement, ReactNode } from "react";
import { THAQShareHistoryTableProps } from "screens/Project/components/HAQ/HAQShareHistory/HAQShareHistoryModal/HAQShareHistoryModal.types";
import { TCountryCode } from "utils/constants/countries.constants";
import { TISODateFormat } from "utils/types";

export enum HAQTable {
  Id = "id",
  Name = "name",
  Status = "status",
  OriginalStatus = "originalStatus",
  Question = "question",
  AuthoringOrganization = "authoringOrganization",
  HAOrganization = "HAOrganization",
  DueDate = "dueDate",
  SubmissionStatus = "submissionStatus",
  SentStatus = "sentStatus",
  Domain = "domain",
  Topic = "topic",
  Country = "country",
  Actions = "actions",
  TenantId = "tenantId",
  SubmissionDetails = "submissionDetails",
  NextAction = "nextAction",
  Type = "type",
  RowActions = "rowActions",
}

export enum HAQTableFilter {
  OnlyMyQuestions = "onlyMyQuestions",
  StartDueDate = "startDueDate",
  EndDueDate = "endDueDate",
  Domain = "domain",
}

export type THAQRowData = {
  [HAQTable.Id]: string;
  [HAQTable.Name]: string;
  [HAQTable.AuthoringOrganization]: string;
  [HAQTable.Status]: string | undefined;
  [HAQTable.SubmissionDetails]: ReactNode;
  [HAQTable.Question]: string;
  [HAQTable.DueDate]: TISODateFormat | undefined;
  [HAQTable.Country]: TCountryCode | "";
  [HAQTable.TenantId]: string | undefined;
  [HAQTable.Type]: string;
  [HAQTable.Domain]: string;
  [HAQTable.Topic]: string;
  [HAQTable.NextAction]?: ReactElement;
  [HAQTable.RowActions]: ReactElement;
} & THAQRowDataFilters;

export type THAQRowDataDeprecated = {
  [HAQTable.Id]: string;
  [HAQTable.Name]: string;
  [HAQTable.AuthoringOrganization]: string;
  [HAQTable.Status]: string;
  [HAQTable.OriginalStatus]: string;
  [HAQTable.Question]: string;
  [HAQTable.DueDate]: TISODateFormat | string | undefined;
  [HAQTable.SubmissionStatus]?: string;
  [HAQTable.SentStatus]: string;
  [HAQTable.Country]: TCountryCode | "";
  [HAQTable.TenantId]: string | undefined;
  [HAQTable.Type]: string;
  [HAQTable.Topic]: string;
  [HAQTable.NextAction]?: ReactElement;
  [HAQTable.RowActions]: ReactElement;
} & THAQRowDataFilters &
  THAQRowActions;

export type THAQTableRowData = Pick<THAQRowData, HAQTable.Id>;

export type THAQFilterRowData = Pick<
  THAQRowData,
  | HAQTable.AuthoringOrganization
  | HAQTable.Country
  | HAQTable.Domain
  | HAQTable.TenantId
>;

export type THAQRowDataFilters = {
  [HAQTableFilter.OnlyMyQuestions]?: string;
  [HAQTableFilter.StartDueDate]?: string;
  [HAQTableFilter.EndDueDate]?: string;
  [HAQTableFilter.Domain]: string;
};

type THAQRowActions = {
  [HAQTable.Actions]?: {
    shareHistoryActionData: THAQShareHistoryTableProps[];
  };
};

export enum HAQTableTabs {
  All = "all",
  Questions = "questions",
  Responses = "responses",
}

export type TNumberHAQsByTab = {
  unsubmittedQuestions: number;
  unsubmittedResponses: number;
  all: number;
};

export enum HAQNonImportedType {
  Inline = "INLINE",
  Standard = "STANDARD",
}
